import {v4 as uuidv4} from 'uuid';
import {AfterViewChecked, Component, ElementRef, inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router, RouterLink, RouterOutlet} from "@angular/router";
import {ApiService, ChatMessage, ChatMessageRequest} from "../../../services/api.service";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {DatePipe, JsonPipe, NgClass, NgForOf, NgIf, NgStyle} from "@angular/common";
import {ActionsContainerComponent} from "../../../core/actions-container/actions-container.component";
import {MatButtonModule} from "@angular/material/button";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {AuthService} from "../../../auth/services/auth.service";
import {MatIconModule} from "@angular/material/icon";
import {UiScrollModule} from "ngx-ui-scroll";
import {RouteContainerComponent} from "../../../core/route-container/route-container.component";
import {BackButtonComponent} from "../../../core/back-button/back-button.component";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RequireClaimsDirective} from "../../../auth/components/require-claims.directive";
import {ChatMessageNodeComponent} from "../chat-message-node/chat-message-node.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {Clipboard} from "@angular/cdk/clipboard";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-session-chat',
  standalone: true,
  imports: [
    UiScrollModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    NgClass,
    ActionsContainerComponent,
    MatButtonModule,
    NgForOf,
    JsonPipe,
    MatProgressBarModule,
    MatIconModule,
    DatePipe,
    RouteContainerComponent,
    RouterLink,
    RouterOutlet,
    BackButtonComponent,
    MatSidenavModule,
    MatToolbarModule,
    RequireClaimsDirective,
    ChatMessageNodeComponent,
    NgStyle,
    MatTooltipModule
  ],
  templateUrl: './session-chat.component.html',
  styleUrl: './session-chat.component.sass',
  encapsulation: ViewEncapsulation.None,
})
export class SessionChatComponent implements OnInit, AfterViewChecked {
  @ViewChild('historyDiv') historyDiv?: ElementRef;
  protected readonly snackBar = inject(MatSnackBar)
  sessionId?: string
  sub: string
  form: FormGroup
  localHistory: ChatMessage[] = []
  loading = false
  routerEvent: any
  isAdmin = false

  constructor(
    readonly auth: AuthService,
    readonly api: ApiService,
    readonly fb: FormBuilder,
    readonly route: ActivatedRoute,
    readonly router: Router,
    readonly clipboard: Clipboard,
  ) {
    const session = this.auth.getSession()!
    if (!session) {
      throw new Error('user not logged in')
    }
    this.sub = session.identity.sub
    this.form = this.fb.group({
      prompt: ['']
    })
    this.isAdmin = this.auth.isSuperUser()
  }

  ngOnInit(): void {
    this.sessionId = this.route.snapshot.params['sessionId']
    this.api.getSessionChat(this.sessionId!).subscribe({
      next: (r) => {
        this.localHistory = r
        setTimeout(() =>
          this.scrollHistoryContainerToBottom(),
          300
        )
      }
    })
  }

  ngAfterViewChecked() {
  }

  submit(): void {
    if (this.form.valid) {
      const prompt = this.form.value['prompt'].trim()
      if (!prompt.length) {
        return
      }
      const now = new Date()
      const localMessage: ChatMessage = {
        id: uuidv4(),
        refId: null,
        timestamp: now.toISOString(),
        type: 'human',
        sender: this.sub,
        message: prompt,
      }
      this.localHistory.push(localMessage)
      this.form.reset({
        prompt: ''
      }, { emitEvent: true })
      this.loading = true
      setTimeout(() => {
        this.scrollHistoryContainerToBottom()
      }, 250)
      this.api.postSessionChat(this.sessionId!, {
        id: localMessage.id,
        message: localMessage.message
      }).subscribe({
        next: (r) => {
          this.loading = false
          this.localHistory.push(r)
          setTimeout(() => {
            this.scrollHistoryContainerToBottom()
          }, 250)
        },
        error: (err) => {
          console.error(err)
          this.loading = false
        }
      })
    }
  }

  scrollHistoryContainerToBottom() {
    if (!this.historyDiv) {
      return
    }
    try {
      this.historyDiv.nativeElement.scrollTop =
        this.historyDiv.nativeElement.scrollHeight - this.historyDiv.nativeElement.offsetHeight
    } catch {
    } finally {
    }
  }

  onSidePanelChange(isOpen: boolean) {
    if (!isOpen) {
      this.router.navigate([
        'sessions/preview/', this.sessionId!, 'chat'
      ])
        .catch((e) => console.error('Router error', e))
        .finally(() => {
          // console.debug('Closed side panel.')
        })
    }
  }

  copyMessage(message: ChatMessage) {
    this.clipboard.copy(message.message)
    this.snackBar.open('Message copied to clipboard', 'Ok', {
      politeness: 'polite',
      duration: 1200,
      verticalPosition: 'top'
    })
  }
}
